import axios from "axios";
import env from "../../constants/apiConst";

export const __GetDependency = async (token, body, page) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${env.DEPENDENCY_GET}?page=${page || 1}`, options);
  return res;
};

export const __ShowDependency = async (token, id) => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${env.DEPENDENCY_SHOW}/${id}`, options);
  return res;
};

export const __Dependency_Not_Paginate = async (token) => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${env.DEPENDENCY_NOT_PAGINATE}`, options);
  return res;
};
